module.exports = __webpack_public_path__ + "assets/img/filter.active.15fbadbe.svg";